var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-simple-checkbox',_vm._b({attrs:{"value":_vm.value,"color":"primary","ripple":false},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-simple-checkbox',_vm.options,false))
}
var staticRenderFns = []

export { render, staticRenderFns }